import { Button, PageHeader } from 'components';
import { Form, Input, Row, Col, Spin, List, Typography } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useChains from '../useChains';
import { useParams } from 'react-router-dom';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { form, handleCreateOrUpdate, loading, chainsCompanies } = useChains(
    false,
    id,
  );

  const onFinish = async (values) => {
    await handleCreateOrUpdate(values, id);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const handleCreate = () => {
    form.submit();
  };

  const title = isNew ? t('CREARE CATENA') : t('MODIFICA CATENA');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          <Form
            form={form}
            name='basic'
            wrapperCol={{
              span: 24,
            }}
            initialValues={{
              title: '',
            }}
            onFieldsChange={(changedFields) => {
              form.setFields([
                {
                  name: changedFields[0].name[0],
                  errors: [],
                },
              ]);
            }}
            layout={'vertical'}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
          >
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label={t('Titolo')} name='title'>
                  <Input />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          {/*{chainsCompanies.map()}*/}
          {!isNew && chainsCompanies.length > 0 && (
            <Row gutter={24}>
              <Col span={12}>
                <List
                  bordered
                  dataSource={chainsCompanies.map(
                    (i) => `${i.title} (${i.shopping_center?.title})`,
                  )}
                  renderItem={(item) => <List.Item>{item}</List.Item>}
                />
              </Col>
            </Row>
          )}
          <br />
        </Spin>
        <Button
          onClick={handleCreate}
          width={'150px'}
          big
          icon={<CheckOutlined />}
          loading={loading}
        >
          {t('Invia')}
        </Button>
      </div>
    </div>
  );
};

export default Edit;
